import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

export function handleMarketspaceAvailable(property: IClientConfigProperty): void {
  if (!Features.isMarketplaceEnabled()) {
    return;
  }

  const isAvailable = Boolean(property) && property.value === 'true';
  Entities.marketplace.setAvailable(isAvailable);
}
